$(function () {
  // ローダー終了
  function end_loader() {
    $(".bl_loader").fadeOut(800);
  }
  // テキスト表示
  function show_txt() {
    $(".bl_loader .bl_loader_logo").fadeIn(600);
  }

  // タイマー処理
  $(window).on("load", function () {
    setTimeout(function () {
      show_txt();
    }, 1000);
    setTimeout(function () {
      end_loader();
      $("body").removeClass("el_loading");
      $("body").addClass("el_loaded");
    }, 3000);
  });

  setTimeout(function () {
    if (document.getElementsByTagName("html")[0].classList.contains("wf-active") != true) {
      document.getElementsByTagName("html")[0].classList.add("loading-delay");
    }
  }, 3000);

  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value = window.outerWidth > 360 ? "width=device-width,initial-scale=1" : "width=360";
    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }
  addEventListener("resize", switchViewport, false);
  switchViewport();

  var showFlag = 0;
  const modal = document.querySelector("#js_navBody");
  $("#js_navBtn,#js_navBody,.js_touchPoint").click(function () {
    if (showFlag == 0) {
      showFlag = 1;
      $("#js_navBtn").addClass("open");
      $(".js_navBtnClose").addClass("open");
      $("#js_navBody").addClass("open");
      $(".js_hdr_inner_logo_img").addClass("open");
      MinimalModal.show(modal);
    } else {
      showFlag = 0;
      $("#js_navBtn").removeClass("open");
      $(".js_navBtnClose").removeClass("open");
      $("#js_navBody").removeClass("open");
      $(".js_hdr_inner_logo_img").removeClass("open");
      MinimalModal.close(modal);
    }
  });

  /* hover class追加 */
  var ua = navigator.userAgent;
  if (ua.indexOf("iPhone") > 0 || ua.indexOf("iPod") > 0 || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)) {
    // スマートフォン用コード
  } else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
    // タブレット用コード
  } else {
    // PC用コード
    $('a, input[type="button"], input[type="submit"], button, .js_touch_hover').hover(
      function () {
        $(this).addClass("hover");
      },
      function () {
        $(this).removeClass("hover");
      }
    );
  }

  //画面高さ
  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };
  let vw = window.innerWidth;
  window.addEventListener("resize", () => {
    if (vw === window.innerWidth) {
      return;
    }
    vw = window.innerWidth;
    setFillHeight();
  });
  setFillHeight();

  $('a[href^="#"]').click(function () {
    var adjust = 65;
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - adjust;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

/* totop btn */
$("#js_totop").hide();
$(window).on("scroll", function () {
  if ($(this).scrollTop() > 100) {
    $("#js_totop").fadeIn("fast");
    $("body").addClass("el_scroll");
  } else {
    $("#js_totop").fadeOut("fast");
    $("body").removeClass("el_scroll");
  }
});

//サムネイル
var sliderThumbnail = new Swiper(".slider-thumbnail", {
  slidesPerView: 10,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

var $swiperSelector = $(".swiper-container");
$swiperSelector.each(function (index) {
  var $this = $(this);
  $this.addClass("swiper-slider-" + index);
  var dragSize = $this.data("drag-size") ? $this.data("drag-size") : 50;
  var freeMode = $this.data("free-mode") ? $this.data("free-mode") : false;
  var loop = $this.data("loop") ? $this.data("loop") : false;
  var slidesDesktop = $this.data("slides-desktop") ? $this.data("slides-desktop") : 1;
  var slidesTablet = $this.data("slides-tablet") ? $this.data("slides-tablet") : 1;
  var slidesMobile = $this.data("slides-mobile") ? $this.data("slides-mobile") : 1;
  var spaceBetween = $this.data("space-between") ? $this.data("space-between") : 20;

  // メイン
  var swiper = new Swiper(".swiper-slider-" + index, {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    direction: "horizontal",
    loop: loop,
    freeMode: freeMode,
    spaceBetween: spaceBetween,
    speed: 500,
    breakpoints: {
      1024: {
        slidesPerView: slidesDesktop,
        speed: 300,
      },
      960: {
        slidesPerView: slidesTablet,
      },
      320: {
        slidesPerView: slidesMobile,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      dragSize: dragSize,
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
  });
});
